import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-facebook-icon',
  templateUrl: './facebook-icon.component.svg',
})
export class FacebookIconComponent {
  @Input() color = '#343E57';
  @Input() width = 20;
  @Input() height = 20;
}
